<div class="ntf-toaster-outer-container bs-enabled" *ngIf="ntfData?.length">
	<div class="ntf-toaster-inner-container align-items-stretch flex-column gap-2 position-relative">
		<div class="ntf-toaster flex-row align-items-center gap-3 p-2 ps-3"
			 *ngFor=" let notification of ntfData"
			 id="{{'notification_'+notification.index}}"
			 [ngStyle]="{'--toaster-color' : !notification.error.type ? '#d73333' : notification.error.type === 'info' ? '#00a414' : notification.error.type === 'warn' ? '#d38800' : ''}">
			<i [ngClass]="{'zmdi' : true, 'zmdi-alert-circle' : notification.error.type !== 'info' , 'zmdi-check-circle' : notification.error.type === 'info'}"></i>
			<div class="ntf-counter animated fadeIn" *ngIf="notification.counter > 1">{{notification.counter}}</div>
			<i class="far fa-spinner fa-spin text-muted" *ngIf="notification.error.showSpinner"></i>
			<!--progress bar?--><!---->
			<span class="f-1-0" [innerHTML]="notification.error.message" *ngIf="!notification.angular"></span>
			<span class="f-1-0" dynamic="notification.error.message" *ngIf="notification.angular"></span>
			<i class="zmdi zmdi-close p-2 text-dark hvr-opacity cursor-pointer" id="closeNotification" (click)="closeNotification(notification.index); $event.stopPropagation();"></i>
		</div>

		<div class="rounded-2 border border-2 border-secondary bg-white d-flex centralize p-1 cursor-pointer hvr-darken-light animated fadeIn"
			 style="position: absolute; top: 0; right: -5px; transform: translateY(-45%); font-size: 11px; line-height: 1;"
			 *ngIf="ntfData?.length > 1"
			 (click)="ns.closeAll()">
			<span>Clear all</span>
		</div>
	</div>
</div>
